// extracted by mini-css-extract-plugin
module.exports = {"overlay":"SuspenseOverlay__overlay___3M8fd"};